import appConstants from '../../../appConstants';
import Events from '../../../utilities/EventEmitter';

const redirectToIBPlanning = (navigate) => () => {
  navigate(appConstants.NAV_URLS.HOME);
};

const getInitialStepData = (enableTraps) => {
  return enableTraps ? { 1: [], 2: [] } : { 1: [] };
};

const getSteps = (enableTraps) => {
  const steps = ['Choose Plan Date', 'Returns', 'IB Bills', 'Trap Bills'];
  return enableTraps ? steps : steps.slice(0, -1);
};

const getTabDataFromConfig = (config, tabID) => {
  if (config && config[tabID] && config[tabID].data) {
    return config[tabID].data;
  }
  return [];
};

const getIBBillsTabs = (config) => {
  if (config) {
    return Object.keys(config).map((key) => ({
      id: key,
      name: config[key].metadata.tabName,
      totalCount:
        config[key]?.data?.reduce(
          (total, trailer) => total + trailer.shipmentsForDestTerminalCount,
          0
        ) || 0,
      selectedCount:
        config[key]?.data?.reduce((total, trailer) => {
          return (
            total +
            trailer.selectedPros.length +
            (trailer.shipmentsForDestTerminal?.filter((shipment) => shipment.isInPlan === 1)
              .length || 0)
          );
        }, 0) || 0
    }));
  } else {
    return [];
  }
};

const getReturnTabs = (tabs, selected) => {
  if(tabs){
    return tabs.map(tab => ({
      id: tab.tabId,
      name: tab.tabName,
      totalCount: tab.totalCount,
      selectedCount: selected[tab.tabId]?.length || 0
    }))
  }
  return [];
};

const getTabTitle = (tabId, tabList) => {
  const tabTitle = tabList.find(tab => tab.id === tabId);
  return tabTitle ? tabTitle.name : "";
}

const getExportFilename = ({ tabId, tabList, sectionTitle }) => {
  const tabTitle = getTabTitle(tabId, tabList);
  if (!tabTitle) return sectionTitle;
  return `${sectionTitle} - ${tabTitle}`;
};

const getShipmentCodes = (params) => {
  return params.data.shipmentCodes?.join(",") || "";
}

const emitRefreshTimerEvent = (headerId) => {
  Events.emit(`ResetRefreshBarTimer-${headerId}`);  
}

export {
  getInitialStepData,
  getSteps,
  redirectToIBPlanning,
  getTabDataFromConfig,
  getIBBillsTabs,
  getReturnTabs,
  getExportFilename,
  getShipmentCodes,
  emitRefreshTimerEvent
};
